export const ADD_TRIGGER = 'ADD_TRIGGER';
export const REMOVE_TRIGGER = 'REMOVE_TRIGGER';
export const SET_SHOULD_TRIGGER = 'SET_SHOULD_TRIGGER';

export const TRIGGER_ACTION_TYPES = [
  ADD_TRIGGER,
  REMOVE_TRIGGER,
  SET_SHOULD_TRIGGER
];
